module.exports = __webpack_public_path__ + "static/media/Cabs2.0-275-50-A.a06244d9.png";